import React, { lazy } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'

import Header from '~/components/header'
import { Alert } from '@grupoboticario/flora-team-react-alert'

const BoasVindas = lazy(() => import('./BOAS_VINDAS'))
const BoasVindasHub = lazy(() => import('./BOAS_VINDAS_HUB'))
const Cadastro = lazy(() => import('./CADASTRO'))
const ResetData = lazy(() => import('./RESET_DATA'))
const EscolheCanal = lazy(() => import('./ESCOLHE_CANAL'))
const EscolheRevendedoraLoja = lazy(() => import('./ESCOLHE_REVENDEDORA_LOJA'))
const EscolheDataResgate = lazy(() => import('./ESCOLHE_DATA_RESGATE'))
const EscolheHorarioResgate = lazy(() => import('./ESCOLHE_HORARIO_RESGATE'))
const Quiz = lazy(() => import('./QUIZ'))
const Resultado = lazy(() => import('./RESULTADO'))
const ShowVoucher = lazy(() => import('./SHOW_VOUCHER'))
const VerifyVoucher = lazy(() => import('./VERIFY_VOUCHER'))
const Products = lazy(() => import('./PRODUCTS'))
const OpcoesHub = lazy(() => import('./OPCOES_HUB'))
const Senha = lazy(() => import('./SENHA'))
const ErroAcesso = lazy(() => import('./ERRO_ACESSO'))

const Dynamic = ({ campaignId, slug }) => {
  const classes = useStyles()

  const { steps, modality } = useSelector((state) => state.campaignReducers.campaign)

  const StepVerify = parseInt(steps?.filter((step) => step?.view === slug?.trim())?.shift()?.step)

  const LayoutDefault = ({ component, disableHeader = false, needPersistedVoucher = false }) => {
    const classes = useStyles()

    const voucher = useSelector((state) => state.voucherReducers.voucher)

    if (needPersistedVoucher && Object.entries(voucher).length === 0) {
      return <Redirect to={`/${campaignId}/BOAS_VINDAS`} />
    }

    return (
      <div className={classes.PAGE_CONTAINER}>
        {disableHeader === false && <Header border={StepVerify === 1} />}
        {component}
      </div>
    )
  }

  LayoutDefault.propTypes = {
    component: PropTypes.node.isRequired,
    disableHeader: PropTypes.bool,
    needPersistedVoucher: PropTypes.bool
  }

  const DynamicPages = {
    BOAS_VINDAS: (props) => (
      <LayoutDefault
        component={modality === 'HUB_DO_PRESENTE' ? <BoasVindasHub {...props} /> : <BoasVindas {...props} />}
      />
    ),
    CADASTRO: (props) => <LayoutDefault component={<Cadastro {...props} />} />,
    RESET_DATA: (props) => <LayoutDefault component={<ResetData {...props} />} />,
    ESCOLHE_CANAL: (props) => <LayoutDefault component={<EscolheCanal {...props} />} needPersistedVoucher />,
    ESCOLHE_REVENDEDORA_LOJA: (props) => (
      <LayoutDefault component={<EscolheRevendedoraLoja {...props} />} needPersistedVoucher />
    ),
    ESCOLHE_DATA_RESGATE: (props) => (
      <LayoutDefault component={<EscolheDataResgate {...props} />} needPersistedVoucher />
    ),
    ESCOLHE_HORARIO_RESGATE: (props) => (
      <LayoutDefault component={<EscolheHorarioResgate {...props} />} needPersistedVoucher />
    ),
    QUIZ: (props) => <LayoutDefault component={<Quiz {...props} />} disableHeader needPersistedVoucher />,
    RESULTADO: (props) => <LayoutDefault component={<Resultado {...props} />} needPersistedVoucher />,
    SHOW_VOUCHER: (props) => <LayoutDefault component={<ShowVoucher {...props} />} needPersistedVoucher />,
    VERIFY_VOUCHER: (props) => <LayoutDefault component={<VerifyVoucher {...props} />} />,
    PRODUCTS: (props) => <LayoutDefault component={<Products {...props} />} />,
    SENHA: (props) => <LayoutDefault component={<Senha {...props} />} needPersistedVoucher />,
    OPCOES_HUB: (props) => <LayoutDefault component={<OpcoesHub {...props} />} needPersistedVoucher />,
    ERRO_ACESSO: (props) => <ErroAcesso {...props} />
  }

  const NOT_FOUND = () => {
    return (
      <div className={classes.PAGE_NOT_FOUND}>
        <Alert
          color='light'
          title='Atenção'
          description='O layout não foi encontrado'
          size='default'
          status='error'
          hideCloseButton
          css={{ width: '100%' }}
        />
      </div>
    )
  }

  const DynamicComponent = DynamicPages[slug?.trim()] || NOT_FOUND
  const DynamicStep = StepVerify > 0 ? StepVerify - 1 : 0

  return [DynamicComponent, DynamicStep]
}

const useStyles = makeStyles((theme) => ({
  PAGE_CONTAINER: {
    width: '100%',
    margin: theme.spacing(5, 4),
    overflow: 'hidden'
  },
  PAGE_NOT_FOUND: {
    backgroundColor: theme.palette.background.default,
    minHeight: window.innerHeight,
    padding: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  }
}))

Dynamic.propTypes = {
  campaignId: PropTypes.string,
  slug: PropTypes.string
}

export default Dynamic
